import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as PriceSheetActions from '../../actions/master-data/price.sheet.actions';

@Injectable()
export class PriceSheetEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) {}

  loadPriceSheets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PriceSheetActions.loadPriceSheets),
      mergeMap(() =>
        this.masterDataService.getAllPriceSheets().pipe(
          map((priceSheets) => PriceSheetActions.loadPriceSheetsSuccess({ priceSheets})),
          catchError((error) => {
            return of(PriceSheetActions.loadPriceSheetFailure({ error: error?.error.error }));
        })
        )
      )
    )
  );

  addPriceSheet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PriceSheetActions.addPriceSheet),
      mergeMap(({ priceSheet }) =>
        this.masterDataService.addNewPriceSheet(priceSheet).pipe(
          mergeMap((saved) => [
            PriceSheetActions.updatePriceSheetSuccess({
              priceSheet: saved,
              message: 'Price Sheet added successfully'
            }),
            PriceSheetActions.loadPriceSheets()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while adding the price sheet';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(PriceSheetActions.loadPriceSheetFailure({ error: errorMessage }));

          })       
        )
      )
    )
  );

  updatePriceSheet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PriceSheetActions.updatePriceSheet),
      mergeMap(({ priceSheet }) =>
        this.masterDataService.updatePriceSheet(priceSheet).pipe(
          mergeMap((saved) => [
            PriceSheetActions.updatePriceSheetSuccess({
              priceSheet: saved,
              message: 'Price Sheet updated successfully'
            }),
            PriceSheetActions.loadPriceSheets()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while updating the price sheet';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(PriceSheetActions.loadPriceSheetFailure({ error: errorMessage }));

          })
        )
      )
    )
  );  

  deletePriceSheet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PriceSheetActions.deletePriceSheet),
      mergeMap(({ id }) =>
        this.masterDataService.deletePriceSheet(id).pipe(
          mergeMap((saved) => [
            PriceSheetActions.deletePriceSheetSuccess({
              message: 'Price Sheet deleted successfully'
            }),
            PriceSheetActions.loadPriceSheets()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while deleting the price sheet';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(PriceSheetActions.loadPriceSheetFailure({ error: errorMessage }));
          })
        )
      )
    )
  );
  
}